import styled from "@emotion/styled"
import Image from "components/media/ImageCLD"
import { useConsole } from "contexts/Console"
import BeautyshotButton from "./BeautyshotButton"

const Root = styled.section`
  display: grid;

  > * {
    grid-area: 1 / 1;
  }
`

const Figure = styled.figure`
  img {
    display: block;
    height: 100vh;
    object-fit: cover;
  }
`

const CTA = styled(BeautyshotButton)`
  align-self: end;
  justify-self: end;
  margin-block-end: 2.5rem;
  margin-inline-end: min(5vw, 4.5rem);
`

export default function ImageSimple({ content = [], theme = "dark-theme" }) {
  const console = useConsole()

  const asset = content.find(item => item.asset)?.asset.asset
  const beautyshot = content.find(item => item.beautyshot)?.beautyshot

  console.log("TestimoneeImageSimple(%o)", content, theme)

  return (
    <Root className={theme}>
      <Figure>
        <Image loading='lazy' sources={asset} alt='' sizes='100vw' />
      </Figure>
      {beautyshot && <CTA beautyshot={beautyshot} />}
    </Root>
  )
}
